export function handleError(response) {
  const { status, data } = response;

  if (status === 200 && data.error) {
    return Promise.reject(data.message || data.messages);
  }

  return response;
}
